import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-board-result',
  templateUrl: './board-result.component.html',
  styleUrls: ['./board-result.component.scss']
})
export class BoardResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
